import { Column } from 'src/model';
import { accountsColumnList } from 'src/utils/tableColumns';

export const SET_ACCOUNT_COLUMNS = 'SET_ACCOUNT_COLUMNS';
export const setTPAccountsColumns = (columns: Column[]) => ({
  type: SET_ACCOUNT_COLUMNS,
  payload: columns,
});

const initialState: Column[] = accountsColumnList;

interface Action {
  type: string;
  payload: Column[];
}

const setTPAccountsColumnsReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_ACCOUNT_COLUMNS:
      return [...action.payload];

    default:
      return state;
  }
};
export default setTPAccountsColumnsReducer;
